export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/illustration2.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I'm a Frontend Developer passionate about crafting interactive,
            accessible, and responsive websites and mobile applications. Check
            out my projects section for some of the websites & mobile apps I've
            built.
          </p>
          <p className="hero--section-description">
            I'm currently open to Job opportunities where I can contribute to
            your business and create delightful user experiences. Feel free to
            contact me if you find my skills useful.
          </p>
        </div>
      </div>
    </section>
  );
}
